// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');

// @vendors
const get = require('lodash/object/get');

// @ actions
const hireContactDataActions = require('actions/hireContactData');
const signaturePatternActions = require('actions/signaturePattern');

// @constants
const actionTypes = require('../constants/actionTypes');
const { CORRESPONDENCE_ADDRESS_CODE } = require('constants/shippingAddress');

const getShippingAddressRequest = () => ({
    type: actionTypes.PROFILE_GET_SHIPPING_ADDRESS_REQUEST,
});

const getShippingAddressOneResultSuccess = shippingAddress => ({
    type: actionTypes.PROFILE_GET_SHIPPING_ADDRESS_ONE_RESULT_SUCCESS,
    payload: {
        shippingAddress,
    }
});

const getShippingAddressNoResultSuccess = () => ({
    type: actionTypes.PROFILE_GET_SHIPPING_ADDRESS_NO_RESULT_SUCCESS,
});

const getShippingAddressFailure = errorDescription => ({
    type: actionTypes.PROFILE_GET_SHIPPING_ADDRESS_FAILURE,
    payload: {
        errorDescription,
    }
});

const addShippingAddressSuccess = response => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_ADD_SUCCESS,
    payload: response
});

const addShippingAddressFailure = errorDescription => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_ADD_FAILURE,
    payload: {
        errorDescription,
    }
});

const updateShippingAddressRequest = () => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_UPDATE,
});

const updateShippingAddressSuccess = response => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_UPDATE_SUCCESS,
    payload: response
});

const updateShippingAddressFailure = errorDescription => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_UPDATE_FAILURE,
    payload: {
        errorDescription,
    }
});

const deleteShippingAddressRequest = () => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_DELETE,
});

const deleteShippingAddressSuccess = response => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_DELETE_SUCCESS,
    payload: response
});

const deleteShippingAddressFailure = errorDescription => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_DELETE_FAILURE,
    payload: {
        errorDescription,
    }
});

const resetWizard = () => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_RESET
});

const reset = () => dispatch => {
    dispatch(resetWizard());
    dispatch(hireContactDataActions.reset());
};

const setVisibleStep = step => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_SET_VISIBLE_STEP,
    payload: {
        step,
    }
});

const setWillCancel = willCancel => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_WILL_CANCEL,
    payload: {
        willCancel,
    }
});

const setEditMode = () => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_SET_EDIT_MODE,
});

const validate = (step, isValid) => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_VALIDATE_STEP,
    payload: {
        step,
        valid: isValid,
    }
});

const scrollToTopToggle = scrollToTop => ({
    type: actionTypes.PROFILE_SHIPPING_ADDRESS_SCROLL_TO_TOP_TOGGLE,
    payload: {
        scrollToTop,
    }
});

const validateShippingAddress = step => (dispatch, getState) => {
    dispatch(hireContactDataActions.validateStep(false));
    dispatch(validate(step, getState().hireContactData.get('isValid')));
};

const getShippingAddress = () => (dispatch, getState) => {
    dispatch(getShippingAddressRequest());

    const  requestData = {
        query : {
            type: [
                CORRESPONDENCE_ADDRESS_CODE,
            ]
        }
    }
    return APIPost({
        dispatch,
        endpoint: 'getShippingAddressList',
        params: requestData
    })
    .then(response => {
        const shippingAddress = get(response, 'domicilios[0]');

        if (!!shippingAddress) {
            dispatch(getShippingAddressOneResultSuccess(shippingAddress));
            dispatch(hireContactDataActions.fillProfileShippingAddress(getState().myProfileShippingAddress.get('shippingAddress')));
        } else {
            dispatch(getShippingAddressNoResultSuccess());
        }
    })
    .catch(response => {
        if (!!response.error) {
            dispatch(getShippingAddressFailure(response.error));
        } else {
            throw response;
        }
    });
}

const updateShippingAddress = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immHireContactData = getState().hireContactData;
        const immProfileShippingAddress = getState().myProfileShippingAddress;
        const requestData = {
            query: {
                codFormatoDomicilio: "ESP",
                domicilioEsp: {
                    anexoVia: immHireContactData.getIn(['others', 'value']),
                    codigoPostal: immHireContactData.getIn(['postalCode', 'value']),
                    localidad: immHireContactData.getIn(['population', 'value']),
                    nombreVia: immHireContactData.getIn(['roadName', 'value']),
                    numeroVia: immHireContactData.getIn(['number', 'value']),
                    pais: immHireContactData.getIn(['country', 'value']),
                    plaza: {
                        provincia: immHireContactData.getIn(['province', 'value'])
                    },
                    tipoVia: immHireContactData.getIn(['roadType', 'value']),
                },
                numDomicilio: immProfileShippingAddress.getIn(['shippingAddress', 'id']),
                token: dataToken,
            }
        };
        dispatch(updateShippingAddressRequest());

        return APIPost({
            dispatch,
            endpoint: 'addressEdit',
            params: requestData,
        })
        .then(response => dispatch(updateShippingAddressSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(updateShippingAddressFailure(response.error));
            } else {
                throw response;
            }
        });
    }

    return new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
}

const addShippingAddress = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immHireContactData = getState().hireContactData;
        const requestData = {
            query: {
                codFormatoDomicilio: "ESP",
                domicilioEsp: {
                    anexoVia: immHireContactData.getIn(['others', 'value']),
                    codigoPostal: immHireContactData.getIn(['postalCode', 'value']),
                    localidad: immHireContactData.getIn(['population', 'value']),
                    nombreVia: immHireContactData.getIn(['roadName', 'value']),
                    numeroVia: immHireContactData.getIn(['number', 'value']),
                    pais: immHireContactData.getIn(['country', 'value']),
                    plaza: {
                        provincia: immHireContactData.getIn(['province', 'value'])
                    },
                    tipoVia: immHireContactData.getIn(['roadType', 'value']),
                },
                tipoDomicilio: CORRESPONDENCE_ADDRESS_CODE,
                token: dataToken,
            }
        };
        dispatch(updateShippingAddressRequest());

        return APIPost({
            dispatch,
            endpoint: 'addressAdd',
            params: requestData,
        })
        .then(response => dispatch(addShippingAddressSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(addShippingAddressFailure(response.error));
            } else {
                throw response;
            }
        });
    }

    return new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
}

const deleteShippingAddress = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immProfileShippingAddress = getState().myProfileShippingAddress;
        const requestData = {
            query: {
                numDomicilio: immProfileShippingAddress.getIn(['shippingAddress', 'id']),
                token: dataToken,
            }
        };
        dispatch(deleteShippingAddressRequest());

        return APIPost({
            dispatch,
            endpoint: 'addressDelete',
            params: requestData,
        })
        .then(response => dispatch(deleteShippingAddressSuccess(response)))
        .catch(response => {
            if (!!response.error) {
                dispatch(deleteShippingAddressFailure(response.error));
            } else {
                throw response;
            }
        });
    }

    return new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
}

module.exports = {
    addShippingAddress,
    deleteShippingAddress,
    getShippingAddress,
    reset,
    scrollToTopToggle,
    setEditMode,
    setVisibleStep,
    setWillCancel,
    updateShippingAddress,
    validateShippingAddress,
};
